import React, { useState } from 'react'
import { Icon } from '../Icon'

interface UICopyLinkProps {
  link?: string
}

const UICopyLink: React.FC<UICopyLinkProps> = ({ link }) => {
  const [isCopy, setIsCopy] = useState<boolean>(false)

  const copyToClipboard = (value: string | undefined) => {
    if (value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {
          setIsCopy(true)
      
          // You can also show a success message here if needed
        })
        .catch((error) => {
          setIsCopy(false)
          console.error('Failed to copy link to clipboard:', error)
          // You can also show an error message here if needed
        })
    }
  }

  return (
    <div className="sm:mx-auto py-3 px-4 flex gap-3 items-center sm:w-full sm:max-w-3xl bg-gray1  rounded-xl mt-4">
      <Icon
        name="IconGlobe"
        width={16}
        height={16}
        strokeWidth={1}
        stroke={'#02698C'}
      />
      <p className="text-sm font-normal text-text1 flex-1">{link}</p>
      <div onClick={() => copyToClipboard(link)} className="cursor-pointer">
        {isCopy ? (
          <p className="text-xs font-normal text-[#02698C] flex-1">
            {'Copied!'}
          </p>
        ) : (
          <Icon
            name="IconCopy"
            width={16}
            height={16}
            strokeWidth={1}
            stroke={'#02698C'}
          />
        )}
      </div>
    </div>
  )
}

export default UICopyLink
